module.exports = __webpack_public_path__ + "img/cod_dg.45012b3a.png";